import { render } from "./DropdownItem.vue?vue&type=template&id=831c664e&scoped=true"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"

import "./DropdownItem.vue?vue&type=style&index=0&id=831c664e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-831c664e"]])

export default __exports__